// 定义常量
export const SET_LOADING = 'SET_LOADING'
export const UPDATE_USERINFO = "UPDATE_USERINFO"     //更新用户的信息
export const SET_SHOW_HOVER = 'SET_SHOW_HOVER';
export const IS_CLICK='IS_CLICK' //防二次点击
export const IS_SHARE='IS_SHARE' //是否是分享过来的
export const SET_PAGE_HOVER='SET_PAGE_HOVER'//当前是第几页

export const VIDEO_PLAYING_MEDIAID= 'VIDEO_PLAYING_MEDIAID' //当前视频播放的id
export const VIDEO_PLAY_LIST =  'VIDEO_PLAY_LIST' //当前视频播放列表
export const VIDEO_PLAY_DERAIL = 'VIDEO_PLAY_DERAIL' //当前播放视频的详情
export const AUDIO_PLAY_DERAIL = 'AUDIO_PLAY_DERAIL' //当前音频播放
export const AUDIO_PLAY_LIST = 'AUDIO_PLAY_LIST' //当前音频列表

export const SET_CURRENT_INDEX = 'SET_CURRENT_INDEX'
export const SET_PLAYING_STATE = 'SET_PLAYING_STATE'
export const SET_FULL_SCREEN = 'SET_FULL_SCREEN'
export const SET_AUDIO_PLAYLIST = 'SET_AUDIO_PLAYLIST'
export const SET_SEQUENCE_LIST = 'SET_SEQUENCE_LIST'
export const SET_PLAY_MODE = 'SET_PLAY_MODE'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js